import PropTypes from 'prop-types';
import { Component } from 'react';

/**
 * NoSSR purposely prevents components from being rendered server side.
 *
 * This component can be useful in a variety of situations:
 * - Escape hatch for broken dependencies not supporting SSR.
 * - Prevent parts of a page or an entire page from being index by search engines.
 */
export default class NoSSR extends Component {
  static propTypes = {
    /** Children will be rendered client side only. */
    children: PropTypes.node,
    /** Fallback component that will be rendered server side. */
    fallback: PropTypes.node
  };

  static defaultProps = {
    children: null,
    fallback: null
  };

  constructor(props) {
    super(props);

    this.state = {
      isMounted: false
    };
  }

  componentDidMount() {
    this.setState({
      isMounted: true
    });
  }

  render() {
    const { children, fallback } = this.props;
    const { isMounted } = this.state;

    return isMounted ? children : fallback;
  }
}
